<template>
  <div :id="echarts" ref="calendarChart" class="container" />
</template>

<script>
import * as echarts from "echarts";
import { EleResize } from "@/utils/eleResize";
import dayjs from "dayjs";
export default {
  name: "calendarChart",
  props: {
    // 接收父组件传递过来的信息
    carData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    },
  },
  mounted: function () {
    const vm = this;
    vm.$nextTick(() => {
      vm.drawChart();
    });
  },
  created: () => {},
  methods: {
    drawChart() {
      var myChart = echarts.init(document.getElementById(this.echarts));
      const date = dayjs(new Date());
      let thisMonth = date.format("YYYY-MM"); //当前月份

      var option = {
        tooltip: {
          backgroundColor: "#3A5B90",
          textStyle: {
            color: "#A7E4FD",
            fontSize: 18,
          },
          formatter: function (params) {
            return "" + params.value[1];
          },
        },

        visualMap: {
          min: 0,
          max: 1000,
          calculable: true,
          align: "left",
          itemWidth: 5,
          inRange: {
            color: ["#013D8D", "#2FD0FF"],
          },
          orient: "vertical",
          right: "10",
          top: "center",
          textStyle: {
            color: "#FFFFFF", // 字体颜色
            fontSize: 12, // 字体大小
          },
        },
        calendar: {
          cellSize: ["auto", 25],
          left: "0",
          right: "15%",
          top: "15%",
          orient: "vertical",
          range: [thisMonth],
          itemStyle: {
            borderColor: "#060F2C",
            borderWidth: 3,
          },
          splitLine: {
            show: false,
          },
          yearLabel: { show: false },
          monthLabel: {
            show: false,
          },
          dayLabel: {
            firstDay: 1,
            margin: 10,
            nameMap: "cn",
            textStyle: {
              color: "#FFFFFF",
              fontSize: 12,
            },
          },
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "calendar",
            symbolSize: 1,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  var d = echarts.number.parseDate(params.value[0]);
                  return d.getDate();
                },
                textStyle: {
                  color: "#fff",
                  fontSize: 16,
                  textShadowColor: "#0B1131",
                  textShadowBlur: 0,
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
              },
            },
            data: this.carData,
          },
          {
            type: "heatmap",
            coordinateSystem: "calendar",
            data: this.carData,
          },
        ],
      };
      option && myChart.setOption(option);
      const listener = function () {
        myChart.resize();
      };
      EleResize.on(document.getElementById(this.echarts), listener);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
